module.exports = new __parcel__URL__("stormcaller.6256ea09.png").toString();